import React, { lazy, Suspense } from 'react';
import Slider from "../components/Slider";
import Section from "../components/Section";
import Section2 from "../components/Section2";
const Intro = lazy(() => import("../components/Intro"));
const HWW = lazy(() => import("../components/HowWeWork"));
const GetInTouch = lazy(() => import("../components/GetInTouch"));
const ExpertQuotes = lazy(()=>import("../components/ExpertQuotes"));
const OurProjects = lazy(()=>import("../components/OurProjects"));
const intro = {
    title: `About DREIS SPACE`,
    content: `<p class="content">We are a fast growing IT company in Bangladesh established in 2020 with a goal to provide high standard solutions to our clients through our IoT, Software’s, Consultancy and other services. We care about our people and their regular life problems. We constantly focus on the regular problems and try to give innovative solutions to the existing problems. We believe in simple solution to complex problems and believe we need full control over our solution so that every problems can have unique technological solution. We have our expert team not only in our country but also from different countries so that we can get the excellent solution from all context. We believe in saying no to thousands of projects, so that we can really focus on the few that are truly important and meaningful to us.   And frankly, we don't settle for anything less than excellence in every group in the company, and we have the self-honesty to admit when we're wrong and the courage to change.</p>`,
    missionVision: [
        {
            title: 'Mission',
            content: 'To offer innovative solutions for all, while paving the way for our industries to get more digitalized.'
        },
        {
            title: 'Vision',
            content: `To make innovations affordable and accessable for every people, to drive a new era of innovations,
            development, growth and productivity.`
        }
    ]
}
const getInTouch = {
    title: "Get in touch with us",
    address: [
        {
            type: `Corporate Office`,
            address: `Level 3, Front Building House - 72, Road - 21, Block - B, Banani, Dhaka - 1213`
        },
        {
            type: `Site office`,
            address: `House-17, Road- 6, Block-H, Banasree, Rampura Dhaka 1219`
        }
    ]
}
const quotes = [
    {
        picture: '/images/faces/masum.jpg',
        name: 'Masum Billah',
        title:'IoT Specialist',
        content:`Internet Of Things (IoT) is very new in our country. But it will create next revolution in our country. It has a very big opportunity in our country as we are a developing country with a lot of problems in our regular life which we want to have a solution but there is no such products to meet our expectations.`
    },
    {
        picture: '/images/faces/hussainalam.jpeg',
        name: 'Husain M M Alam',
        title:'Software Engineering Specialist',
        content:`To accelerate world, information sharing plays vital role and we want to lead the country to the most digitized country around the world through our innovative, efficient and quality services and solutions in software sector with our brilliant minds.`
    }
];
const projects = [
    {
        name:"Anti Theft Vehicle Locking System",
        content:`We are developing an app based bike and car locker which uses no internet connection for the locking system. We target for low cost locking system which will use only app based locking to on or off vehicles. We will integrate gps tracking with this system to provide more enhanced security.`,
        picture:"/images/bike-lock.jpg"
    },
    {
        name:"Automated CPR Machine",
        content:`We have developed an automated cpr machine with a patient monitoring system which will provide cpr to cardiac arrest patients in emergency situations. It will enhance cpr quality and will help reduce cardiac deaths. `,
        picture:"/images/auto-CPR.jpg"
    },
];
const Home = () => {
    return (<>
        <Slider />
        <Section />
        <Section2 />
        <Suspense fallback={null}>
            <HWW title="How we work" tag="h2" />
            <ExpertQuotes title="What Our Experts Say " content={quotes}/>
            <Intro
                title={intro.title}
                content={intro.content}
                missionVision={intro.missionVision}
            />
            <OurProjects title="Our ongoing projects" content={projects}/>
            <GetInTouch title={getInTouch.title} address={getInTouch.address}/>
        </Suspense>
    </>
    );
}

export default Home;

